import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { FN } from "../facilityNetwork/facilityNetworkTheme";

export default function NetworkIntelligenceLoader() {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        width: "100%",
      }}
    >
      <CircularProgress size={28} sx={{ color: FN.primary }} />
      <Typography
        sx={{
          fontFamily: FN.fontFamily,
          fontSize: 14,
          fontWeight: 600,
          color: FN.figmaAccent,
          lineHeight: "20px",
        }}
      >
        Loading Network Intelligence…
      </Typography>
    </Box>
  );
}
